import { SpinningIco } from "./SpinningIco";

/**
 * Full-page / full-section loading state. Uses the SpinningIco so every
 * data-fetch and route transition becomes a brand beat instead of a
 * generic spinner. For button-level / inline loading states keep using
 * lucide's Loader2 - this is for "the whole page is waiting on data"
 * moments.
 */
export function PageLoader({
  label = "Loading…",
  size = 48,
  className = "",
}: {
  label?: string;
  size?: number;
  className?: string;
}) {
  return (
    <div
      className={
        "flex flex-col items-center justify-center gap-3 py-12 text-muted-foreground " +
        className
      }
      role="status"
      aria-live="polite"
    >
      <SpinningIco size={size} />
      <span className="text-xs">{label}</span>
    </div>
  );
}
